import React from 'react';
import './educationCard.css'
import { scheduleIcon, universityIcon } from '../../../../../utils/icons';

const formatDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) return 'No especificado';
  
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear();
  };

  const start = formatDate(startDate);
  const end = formatDate(endDate);
  
  if (start && end) {
    return `${start} - ${end}`;
  } else if (start) {
    return `${start} - Presente`;
  } else if (end) {
    return `Hasta ${end}`;
  }
  
  return 'No especificado';
};

const EducationCard = ({ data }) => {

  return (
    <div className="education-card__item-container"> 
      <div className="education-card__col-1">
        <div className='education-card__info-container'>
            <label>ESTUDIO</label>
            <p><strong>{data.study}</strong></p>
        </div>
      </div>   
      <div className="education-card__col-2">
         <div className="education-card__icon-info-container">
          {universityIcon}
          <div className='education-card__info-container'>
            <p>{data.institution}</p>
            <label>INSTITUCIÓN</label>
          </div>
         </div>
    
         <div className="education-card__icon-info-container">
          {scheduleIcon}
          <div className='education-card__info-container'>
            <p>{formatDateRange(data.startDate, data.endDate)}</p>
            <label>PERIODO</label>
          </div>
         </div>
      </div>
      <div className='education-card__col-3'>
        <p>
          {data.description}
        </p>
      </div>
    </div>
  );
};

export default EducationCard;

